export const calculatorJsonData = {
    Rekonstrukce: {
        Zateplení: {
            tooltip:
                'Program podporuje zateplení obvodových stěn, střechy a podlah, výměnu oken a dveří. Pokud provedete jedno opatření, například pouze zateplení fasády, zvolte dílčí zateplení. Pokud realizujete dvě až tři opatření, například zateplení fasády a výměnu oken, zvolte základní zateplení. Pokud plánujete provést všechna výše uvedená opatření, zvolte komplexní zateplení. Skutečná výše dotace závisí na dosažených energetických parametrech budovy a celkové ploše, na které jsou úsporná opatření prováděna.',
            select: {
                'Není vybráno': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                Dílčí: {
                    median: 127000,
                    grantType: 'A',
                    combine: [
                        {
                            type: 'condition',
                            key: 'zatepleni',
                            error: '',
                        },
                        // {
                        //     type: 'condition',
                        //     key: 'decentralheat',
                        //     error: '',
                        // },
                        {
                            type: 'bonusCondition',
                            key: 'zatepleni',
                            error: '',
                        },
                    ],
                },
                Základní: {
                    median: 313000,
                    grantType: 'A',
                    combine: [
                        {
                            type: 'condition',
                            key: 'zatepleni',
                            error: '',
                        },
                        // {
                        //     type: 'condition',
                        //     key: 'decentralheat',
                        //     error: '',
                        // },
                        {
                            type: 'bonusCondition',
                            key: 'zatepleni',
                            error: '',
                        },
                    ],
                },
                Optimální: {
                    median: 725000,
                    grantType: 'A',
                    combine: [
                        {
                            type: 'condition',
                            key: 'zatepleni',
                            error: '',
                        },
                        // {
                        //     type: 'condition',
                        //     key: 'decentralheat',
                        //     error: '',
                        // },
                        {
                            type: 'bonusCondition',
                            key: 'zatepleni',
                            error: '',
                        },
                    ],
                },
                'Památkově chráněného domu': {
                    median: 152000,
                    grantType: 'A',
                    combine: [
                        {
                            type: 'condition',
                            key: 'zatepleni',
                            error: '',
                        },
                        // {
                        //     type: 'condition',
                        //     key: 'decentralheat',
                        //     error: '',
                        // },
                        {
                            type: 'bonusCondition',
                            key: 'zatepleni',
                            error: '',
                        },
                    ],
                },
            },
            checkbox: {
                'Využiji environmentálně šetrné řešení projektu': {
                    tooltip:
                        'Environmentální hodnocení žádosti slouží k určení dopadu navrhovaných opatření na životní prostředí pomocí výpočetního nástroje SFŽP ČR. Výše dotace je dána počtem dosažených bodů v hodnocení, pro výpočet je použita maximální výše 30 000 Kč.',
                    data: {
                        default: {
                            median: 0,
                            grantType: false,
                            combine: [],
                        },
                        selected: {
                            median: 0,
                            grantType: 'ENVIRO',
                            combine: [
                                {
                                    type: 'with',
                                    key: 'zatepleni',
                                    error: 'Zvolte druh zateplení a dotace se přičte až poté.',
                                },
                            ],
                        },
                    },
                },
                // 'Spolu s dotací na zateplení využiji kotlíkovou dotaci pro domácnost s nižšími příjmy': {
                //     tooltip: '',
                //     data: {
                //         default: {
                //             median: 0,
                //             grantType: false,
                //             combine: [],
                //         },
                //         selected: {
                //             median: 0,
                //             grantType: false,
                //             combine: [
                //                 {
                //                     type: 'with',
                //                     key: 'zatepleni',
                //                     error: 'Zvolte druh zateplení a dotace se přičte až poté.',
                //                 },
                //             ],
                //         },
                //     },
                // },
                'Stínící technika': {
                    tooltip: '',
                    data: {
                        default: {
                            median: 0,
                            grantType: false,
                            combine: [],
                        },
                        selected: {
                            median: 25000,
                            grantType: false,
                            combine: [],
                        },
                    },
                },
            },
        },
        'Výměna zdroje tepla': {
            tooltip:
                'Program podporuje výměnu neekologických kotlů na pevná paliva nižších než 3. třídy a lokálních topidel za nová ekologická zařízení. Dotaci lze získat také na výměnu elektrického vytápění za tepelné čerpadlo. Zvolte typ nového zdroje.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Kotel na biomasu s ručním přikládáním': {
                    median: 80000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Kotel na biomasu automatický': {
                    median: 100000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Kamna na biomasu s ručním přikládáním': {
                    median: 30000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Kamna na biomasu automatický': {
                    median: 45000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Tepelné čerpadlo pro teplovodní vytápění': {
                    median: 80000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Tepelné čerpadlo pro teplovodní vytápění s přípravou teplé vody': {
                    median: 100000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'restrict',
                            key: 'cerpadlo-ohrev',
                            error: 'Dotační program tuto kombinaci neumožňuje. Zvolte jinou položku.',
                        },
                    ],
                },
                'Tepelné čerpadlo pro teplovodní vytápění s přípravou teplé vody napojené na fotovoltaický systém': {
                    median: 130000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'restrict',
                            key: 'cerpadlo-ohrev',
                            error: 'Dotační program tuto kombinaci neumožňuje. Zvolte jinou položku.',
                        },
                    ],
                },
                'Tepelné čerpadlo vzduch-vzduch': {
                    median: 60000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Plynový kondenzační kotel': {
                    median: 35000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
                'Napájení na centrální zásobování teplem': {
                    median: 40000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'decentralheat',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                    ],
                },
            },
        },
        'Ohřev vody s OZE': {
            tooltip:
                'Program podporuje výměnu stávajícího systému na ohřev vody za ohřev pomocí solárních panelů nebo tepelného čerpadla. Společně s dotací na solární ohřev teplé vody nelze poskytnout dotaci na fotovoltaickou elektrárnu bez akumulátorů. Zvolte nový systém ohřevu.',
            select: {
                'Není navrhován': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Solární termický ohřev vody': {
                    median: 45000,
                    grantType: false,
                    combine: [
                        {
                            type: 'restrict',
                            key: 'ohrev-fotovolt',
                            error:
                                'Při podpoře fotovoltaického systému bez akumulátorů nelze současně využít dotaci na solární termický či fotovoltaický systém pro ohřev teplé vody. Zvolte jinou položku.',
                        },
                        {
                            type: 'condition',
                            key: 'ohrev-fotovolt',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'restrict',
                            key: 'cerpadlo-ohrev',
                            error: 'Dotační program tuto kombinaci neumožňuje. Zvolte jinou položku.',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
                'Solární termický ohřev vody s přitápěním': {
                    median: 60000,
                    grantType: false,
                    combine: [
                        {
                            type: 'restrict',
                            key: 'ohrev-fotovolt',
                            error:
                                'Při podpoře fotovoltaického systému bez akumulátorů nelze současně využít dotaci na solární termický či fotovoltaický systém pro ohřev teplé vody. Zvolte jinou položku.',
                        },
                        {
                            type: 'condition',
                            key: 'ohrev-fotovolt',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'restrict',
                            key: 'cerpadlo-ohrev',
                            error: 'Dotační program tuto kombinaci neumožňuje. Zvolte jinou položku.',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
                'Solární fotovoltaický ohřev vody': {
                    median: 45000,
                    grantType: false,
                    combine: [
                        {
                            type: 'restrict',
                            key: 'ohrev-fotovolt',
                            error:
                                'Při podpoře fotovoltaického systému bez akumulátorů nelze současně využít dotaci na solární termický či fotovoltaický systém pro ohřev teplé vody. Zvolte jinou položku.',
                        },
                        {
                            type: 'condition',
                            key: 'ohrev-fotovolt',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'restrict',
                            key: 'cerpadlo-ohrev',
                            error: 'Dotační program tuto kombinaci neumožňuje. Zvolte jinou položku.',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
                'Ohřev vody s tepelným čerpadlem': {
                    median: 45000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'ohrev-fotovolt',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'restrict',
                            key: 'cerpadlo-ohrev',
                            error: 'Dotační program tuto kombinaci neumožňuje. Zvolte jinou položku.',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
            },
        },
        'Domácí fotovoltaická elektrárna': {
            tooltip:
                'Podpora se vztahuje na fotovoltaické systémy pro domácí výrobu elektrické energie v rodinném domě. Malou instalací se rozumí instalace od 6 do 12 fotovoltaických panelů (podle typu panelu) s minimálním výkonem 2 kWp. Větší instalace zahrnuje 16 až 35 fotovoltaických panelů (podle typu panelu) s výkonem od 5 do 10 kWp. Současně s fotovoltaickým systémem bez akumulátorů nelze podpořit solární ohřev teplé vody. Zvolte typ instalace.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Minimální instalace (2 kWp) bez baterií': {
                    median: 60000,
                    grantType: false,
                    combine: [
                        {
                            type: 'restrict',
                            key: 'ohrev-fotovolt',
                            error:
                                'Při podpoře fotovoltaického systému bez akumulátorů nelze současně využít dotaci na solární termický či fotovoltaický systém pro ohřev teplé vody. Zvolte jinou položku.',
                        },
                        {
                            type: 'condition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                    ],
                },
                'Střední instalace bez baterií (6 kWp)': {
                    median: 100000,
                    grantType: false,
                    combine: [
                        {
                            type: 'restrict',
                            key: 'ohrev-fotovolt',
                            error:
                                'Při podpoře fotovoltaického systému bez akumulátorů nelze současně využít dotaci na solární termický či fotovoltaický systém pro ohřev teplé vody. Zvolte jinou položku.',
                        },
                        {
                            type: 'condition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                    ],
                },
                'Malá instalace s baterií (3,5 kWp + 5 kWh)': {
                    median: 125000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
                'Větší instalace s baterií (8 kWp + 10 kWh)': {
                    median: 200000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
            },
        },
        'Řízené větrání, rekuperace': {
            tooltip: 'Podpora se vztahuje na systémy řízeného větrání se zpětným získáváním tepla včetně příslušenství a zapojení. Zvolte typ systému.',
            select: {
                'Není navrhováno': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Větrání s rekuperací': {
                    median: 105000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        }
                    ],
                },
            },
        },
        'Teplo z odpadní vody': {
            tooltip:
                'Podpora je určena na systémy využívající teplo z odpadní vody včetně příslušenství a zapojení. U decentrálního systému je do výsledku započítána dotace za jedno odběrné místo. Podpořit lze až tři odběrná místa na jeden rodinný dům.',
            select: {
                'Není navrhováno': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                Centrální: {
                    median: 50000,
                    grantType: false,
                    combine: [
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo-odpad',
                            error: '',
                        },
                        {
                            type: 'condition',
                            key: 'teplo-odpad',
                            error: '',
                        },
                    ],
                },
                'Decentrální systém – 1 odběrové místo': {
                    median: 5000,
                    grantType: false,
                    combine: [
                        // {
                        //     type: 'with',
                        //     key: 'decentralheat',
                        //     error: 'Toto opatření lze podpořit.',
                        // },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dešťovky a Dobíjecí stanice pro elektromobily.',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo-odpad',
                            error: '',
                        },
                    ],
                },
                'Decentrální systém – 2 odběrová místa': {
                    median: 10000,
                    grantType: false,
                    combine: [
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dešťovky a Dobíjecí stanice pro elektromobily.',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo-odpad',
                            error: '',
                        },
                    ],
                },
                'Decentrální systém – 3 odběrová místa': {
                    median: 15000,
                    grantType: false,
                    combine: [
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dešťovky a Dobíjecí stanice pro elektromobily.',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'teplo-odpad',
                            error: '',
                        },
                    ],
                },
            },
        },
        // 'Stínicí technika': {
        //     tooltip: 'Podporovány jsou venkovní stínicí systémy (žaluzie, rolety …) podle typu ovládání. Vyberte typ ovládání.',
        //     select: {
        //         'Není navrhována': {
        //             median: 0,
        //             grantType: false,
        //             combine: [],
        //         },
        //         'S ručním ovládáním': {
        //             median: 10000,
        //             grantType: false,
        //             combine: [
        //                 {
        //                     type: 'with',
        //                     key: 'zatepleni',
        //                     error: 'Toto opatření lze podpořit pouze v kombinaci se zateplením. Vyberte položku Zateplení.',
        //                 },
        //                 {
        //                     type: 'bonus',
        //                     key: 'zatepleni',
        //                     error: '',
        //                 },
        //             ],
        //         },
        //         'S inteligentním řízením': {
        //             median: 20000,
        //             grantType: false,
        //             combine: [
        //                 {
        //                     type: 'with',
        //                     key: 'zatepleni',
        //                     error: 'Toto opatření lze podpořit pouze v kombinaci se zateplením. Vyberte položku Zateplení.',
        //                 },
        //                 {
        //                     type: 'bonus',
        //                     key: 'zatepleni',
        //                     error: '',
        //                 },
        //             ],
        //         },
        //     },
        // },
        'Zelená střecha': {
            tooltip:
                'Dotace se poskytuje na výstavbu zelených střech (extenzivních, polointenzivních a intenzivních) na budovách k bydlení, případně na dalších doplňkových nadzemních stavbách žadatele. Přesná výše dotace závisí na typu zelené střechy a velikosti plochy vegetačního souvrství.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Bude součástí projektu': {
                    median: 40000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani', 'teplo-odpad'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Dešťovky, Dobíjecí stanice pro elektromobily a Využití tepla z odpadní vody – decentrální systémy.',
                        },
                    ],
                },
            },
        },
        Dešťovka: {
            tooltip:
                'Program podporuje systémy na zachytávání dešťové vody pro zálivku zahrady nebo využití v domácnosti. Dotaci lze získat na systémy pro využívání šedé odpadní vody v domácnosti, případně pro i zálivku. Zvolte vhodný systém.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Dešťová voda pro zálivku': {
                    median: 27000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'teplo-odpad',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani', 'teplo-odpad'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dobíjecí stanice pro elektromobily a Využití tepla z odpadní vody – decentrální systémy.',
                        },
                    ],
                },
                'Dešťová voda pro zálivku a splachování WC': {
                    median: 37000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'teplo-odpad',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani', 'teplo-odpad'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dobíjecí stanice pro elektromobily a Využití tepla z odpadní vody – decentrální systémy.',
                        },
                    ],
                },
                'Systém pro využití odpadní (šedé) vody': {
                    median: 70000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'teplo-odpad',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani', 'teplo-odpad'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dobíjecí stanice pro elektromobily a Využití tepla z odpadní vody – decentrální systémy.',
                        },
                    ],
                },
                'Systém pro využití odpadní a dešťové vody': {
                    median: 80000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'teplo-odpad',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani', 'teplo-odpad'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dobíjecí stanice pro elektromobily a Využití tepla z odpadní vody – decentrální systémy.',
                        },
                    ],
                },
            },
        },
        'Dobíjecí stanice pro elektromobily': {
            tooltip: 'Podpora se poskytuje na pořízení a instalaci dobíjecí stanice pro elektromobil a dalších zařízení nezbytných pro její provoz.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Bude instalována min. 1 stanice': {
                    median: 15000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'charger',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'zatepleni',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'teplo',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'strecha',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'fve',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'vetrani',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'ohrev-oze',
                            error: ''
                        },
                        {
                            type: 'bonus',
                            key: 'teplo-odpad',
                            error: '',
                        },
                        {
                            type: 'bonus',
                            key: 'destovka',
                            error: '',
                        },
                        {
                            type: 'withAny',
                            keys: ['zatepleni', 'decentralheat', 'ohrev-fotovolt', 'fve', 'vetrani', 'teplo-odpad'],
                            error: 'Toto opatření lze podpořit pouze v kombinaci s jiným opatřením kromě následujících: Zelené střechy, Dešťovky a Využití tepla z odpadní vody – decentrální systémy.',
                        },
                    ],
                }
            },
        },
    },
    Novostavba: {
        'Energetický standard domu': {
            tooltip:
                'Program podporuje výstavbu či nákup: 1/&nbsp;nového domu v nízkoenergetickém standardu s nízkou spotřebou energie, 2/&nbsp;novostavbu splňující základní požadavky kladené na pasivní stavby nebo 3/&nbsp;pasivního (popř. nulového) domu, který využívá ve větší míře energii z obnovitelných zdrojů. Přinákupu již dokončené novostavby není poskytována dotace na projektovou dokumentaci.',
            select: {
                'Není vybrán': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                // 'Nízkoenergetický dům': {
                //     median: 200000,
                //     grantType: 'B',
                //     combine: [
                //         {
                //             type: 'condition',
                //             key: 'enerstandard',
                //             error: '',
                //         },
                //         {
                //             type: 'bonusCondition',
                //             key: 'enerstandard',
                //             error: '',
                //         },
                //     ],
                // },
                // 'Pasivní dům': {
                //     median: 350000,
                //     grantType: 'B',
                //     combine: [
                //         {
                //             type: 'condition',
                //             key: 'enerstandard',
                //             error: '',
                //         },
                //         {
                //             type: 'bonusCondition',
                //             key: 'enerstandard',
                //             error: '',
                //         },
                //     ],
                // },
                'Pasivní dům s vyšším podílem OZE': {
                    median: 535000,
                    grantType: false,
                    combine: [
                        {
                            type: 'condition',
                            key: 'enerstandard',
                            error: '',
                        },
                        {
                            type: 'bonusCondition',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
            },
            checkbox: {
                'Využiji environmentálně šetrné řešení projektu': {
                    tooltip:
                        'Environmentální hodnocení žádosti slouží k určení dopadu navrhovaných opatření na životní prostředí pomocí výpočetního nástroje SFŽP ČR. Výše dotace je dána počtem dosažených bodů v hodnocení, pro výpočet je použita maximální výše 30 000 Kč.',
                    data: {
                        default: {
                            median: 0,
                            grantType: false,
                            combine: [],
                        },
                        selected: {
                            median: 0,
                            grantType: 'ENVIRO',
                            combine: [
                                {
                                    type: 'with',
                                    key: 'enerstandard',
                                    error: 'Zvolte energetický standard domu a dotace se přičte až poté.',
                                },
                            ],
                        },
                    },
                },
            },
        },
        'Zelená střecha': {
            tooltip:
                'Dotace se poskytuje na výstavbu zelených střech (extenzivních, polointenzivních a intenzivních) na budovách k bydlení, případně na dalších doplňkových nadzemních stavbách žadatele. Přesná výše dotace závisí na typu zelené střechy a velikosti plochy vegetačního souvrství.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Bude součástí projektu': {
                    median: 40000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
            },
        },
        Dešťovka: {
            tooltip:
                'Program podporuje systémy na zachytávání dešťové vody pro zálivku zahrady nebo využití v domácnosti. Dotaci lze získat na systémy pro využívání šedé odpadní vody v domácnosti, případně pro i zálivku. Zvolte vhodný systém.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Dešťová voda pro zálivku a splachování WC': {
                    median: 37000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
                'Systém pro využití odpadní (šedé) vody': {
                    median: 70000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
                'Systém pro využití odpadní a dešťové vody': {
                    median: 80000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
            },
        },
        'Teplo z odpadní vody': {
            tooltip:
                'Podpora je určena na systémy využívající teplo z odpadní vody včetně příslušenství a zapojení. U decentrálního systému je do výsledku započítána dotace za jedno odběrné místo. Podpořit lze až tři odběrná místa na jeden rodinný dům.',
            select: {
                'Není navrhováno': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                Centrální: {
                    median: 40000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
                'Decentrální systém – 1 odběrové místo': {
                    median: 5000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
                'Decentrální systém – 2 odběrová místa': {
                    median: 10000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
                'Decentrální systém – 3 odběrová místa': {
                    median: 15000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
            },
        },
        'Dobíjecí stanice pro elektromobily': {
            tooltip: 'Podpora se poskytuje na pořízení a instalaci dobíjecí stanice pro elektromobil a dalších zařízení nezbytných pro její provoz.',
            select: {
                'Není navrhována': {
                    median: 0,
                    grantType: false,
                    combine: [],
                },
                'Bude instalována min. 1 stanice': {
                    median: 15000,
                    grantType: false,
                    combine: [
                        {
                            type: 'with',
                            key: 'enerstandard',
                            error: 'Zvolte položku Energetický standard domu.',
                        },
                        {
                            type: 'bonus',
                            key: 'enerstandard',
                            error: '',
                        },
                    ],
                },
                // 'Budou instalovány 2 stanice': {
                //     median: 60000,
                //     grantType: false,
                //     combine: [
                //         {
                //             type: 'with',
                //             key: 'enerstandard',
                //             error: 'Zvolte položku Energetický standard domu.',
                //         },
                //         {
                //             type: 'bonus',
                //             key: 'enerstandard',
                //             error: '',
                //         },
                //     ],
                // },
            },
        },
    },
};
